(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tur/gameguide/assets/javascripts/views/spelguidearticle.js') >= 0) return;  svs.modules.push('/components/tur/gameguide/assets/javascripts/views/spelguidearticle.js'); 
(function(Backbone, _, svs) {
  'use strict';

  svs.tur = svs.tur || {};
  svs.tur.views = svs.tur.views || {};
  svs.tur.views.gameguide = svs.tur.views.gameguide || {};

  svs.tur.views.gameguide.SpelguideArticle = Marionette.View.extend({
    className: 'panel panel-default',

    template: function(data) {
      return svs.tur.gameguide.templates.spelguidearticle(data);
    },

    templateContext: function() {
      return {
        article: this.model.omit('title')
      };
    }
  });
})(Backbone, _, svs);

 })(window);